export default function configs(labels, datasets) {
    return {
        data: {
            labels,
            datasets
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    labels: {
                        color: '#fff',
                        font: { size: 14 }
                    }
                },
                tooltip: {
                    backgroundColor: "#222",
                    titleColor: "#fff",
                    bodyColor: "#fff",
                    borderColor: "#4F8EF7",
                    borderWidth: 2,
                    borderRadius: 8,
                    padding: 12,
                    displayColors: true,
                    caretSize: 8,
                    titleFont: { size: 16, weight: "bold" },
                    bodyFont: { size: 15 },
                    callbacks: {
                        // Label: capitalize cada palavra
                        label: function (context) {
                            let label = context.label || '';
                            label = label
                                .toLowerCase()
                                .split(' ')
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .join(' ');
                            let value = context.parsed !== undefined ? context.parsed : '';

                            if (label === "Sem Rede Ac")
                                label = "Sem Rede AC"

                            return `  ${label}: ${value}`;
                        }
                    }
                }
            }
        }
    }
}